import { render } from "./contact.vue?vue&type=template&id=4f083552"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=4f083552&lang=scss"

import exportComponent from "D:\\丹捷\\项目新\\source\\web_site\\sirimuch\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__